import React from 'react'

import { Gem } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { tokenService } from '@/core/api/services/tokenService'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface NoTokensModalProps {
	isOpen: boolean
	onClose: () => void
	availableTokens: number
	maxTokens: number
}

export const NoTokensModal: React.FC<NoTokensModalProps> = ({
	isOpen,
	onClose,
	availableTokens,
	maxTokens,
}) => {
	const { t } = useTranslation('campaigns')
	const navigate = useNavigate()

	const handleUpgrade = () => {
		navigate('/settings?tab=subscription')
		onClose()
	}

	const resetDate = tokenService.getResetDateDisplay()

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="sm:max-w-[500px] border-0">
				<div className="flex flex-col text-left py-8 px-6 gap-6">
					<div className="flex items-center gap-3">
						<DialogTitle className="text-lg font-medium">
							{t('ai.tokens.available', {
								count: availableTokens,
								total: maxTokens,
							})}
						</DialogTitle>
					</div>

					<div className="space-y-3">
						<p className="text-sm text-muted-foreground">
							{t('ai.tokens.reset', { date: resetDate })}
						</p>

						<p className="text-sm text-muted-foreground">
							{t('ai.tokens.subscribe')}
						</p>
					</div>

					<div className="h-24" />

					<div className="flex gap-3">
						<Button
							variant="outline"
							onClick={onClose}
							className={`${availableTokens <= 0 ? 'flex-1' : 'w-full'} rounded-full`}
						>
							{t('ai.tokens.close')}
						</Button>
						{availableTokens <= 0 && (
							<Button
								onClick={handleUpgrade}
								className="flex-1 rounded-full flex items-center justify-center gap-2 bg-white text-black hover:bg-white/90"
							>
								{t('ai.tokens.upgrade')}
								<Gem className="w-4 h-4" />
							</Button>
						)}
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
